import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';

export const CompleteEngagementEvent = createAsyncThunk(
    'timelines/completeEngagementEvent',
    async (arg: { engagementId: number; eventId: string }, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            await axios.put(
                `/api/Marketplace/Engagements/${arg.engagementId}/CompleteEvent/${arg.eventId}`
            );
        } catch (error: any) {
            const message =
                error?.response?.data?.title ||
                'Failed to complete the step. Please try again.';
            createNotification(message, 'error');
            throw error;
        }
    }
);
